const e = "data:image/svg+xml,%3csvg%20width='13'%20height='10'%20viewBox='0.5%200%2012.5%2010'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cline%20x1='0'%20y1='-1'%20x2='4.92728'%20y2='-1'%20transform='matrix(0.698324%200.715782%20-0.698324%200.715782%200.902588%205)'%20stroke='white'%20stroke-width='2'%20stroke-linecap='round'/%3e%3cpath%20d='M5.19361%208L11.972%201.22139'%20stroke='white'%20stroke-width='2'%20stroke-linecap='round'/%3e%3c/svg%3e";
export {
  e as default
};
//# sourceMappingURL=icon-tick.svg.js.map
